import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { freddyTheme } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
const Backdrop = ({ show, switcher }) => {
    return (_jsxs(_Fragment, { children: [_jsx(InteractionTrap, { show: show, onClick: switcher }), _jsx(BackdropElement, { show: show })] }));
};
const InteractionTrap = ({ onClick, show }) => {
    const InteractionTrap = styled.div `
    z-index: 8;
    position: fixed;
    left: 0;
    top: 52px;
    width: 100%;
    height: 100%;
    display: none;

    ${freddyTheme.breakpoint.minWidth('md')} {
      display: ${show ? 'block' : 'none'};
    }
  `;
    return _jsx(InteractionTrap, { onClick: onClick });
};
const BackdropElement = ({ show }) => {
    const BackdropElement = styled.div `
    user-select: none;
    pointer-events: none;
    z-index: 7;
    background-color: ${freddyTheme.color.background.interactiveMainBase};
    display: none;
    height: calc(100% - 48px);
    left: 0;
    opacity: ${show ? 0.15 : 0};
    position: fixed;
    top: 48px;
    width: 100%;
    will-change: opacity;
    transition: opacity 0.25s ease-in-out;

    ${freddyTheme.breakpoint.minWidth('md')} {
      top: 52px;
      display: block;
    }
  `;
    return _jsx(BackdropElement, {});
};
export { Backdrop };
//# sourceMappingURL=Backdrop.js.map